import { WbTooltip } from '../WbTooltip';
import { FC, MouseEventHandler } from 'react';
import { WbButton } from '../WbButton';
import { LeftPanelCloseIcon, LeftPanelOpenIcon } from '../Icons';
import { DockDirection } from './WbDockableGroup';

interface PrimaryPanelToggleButtonProps {
  onClick?: MouseEventHandler<HTMLElement>;
  ariaLabel: string;
  expanded: boolean;
  direction?: DockDirection;
  style?: React.CSSProperties;
  position?: 'start' | 'end';
}

const transformByVariant: Record<string, string> = {
  'vertical-start': 'rotate(90deg)',
  'vertical-end': 'rotate(-90deg)',
  'horizontal-end': 'scaleX(-1)',
};

export const PrimaryPanelToggleButton: FC<PrimaryPanelToggleButtonProps> = ({
  onClick,
  ariaLabel,
  expanded,
  direction = 'horizontal',
  position = 'start',
  style,
}) => {
  const iconTransform = transformByVariant[`${direction}-${position}`];
  const Icon = expanded ? LeftPanelCloseIcon : LeftPanelOpenIcon;

  return (
    <WbTooltip title={ariaLabel}>
      <WbButton
        icon={
          <span style={{ display: 'flex', transform: iconTransform }}>
            <Icon fontSize="small" />
          </span>
        }
        style={{
          minWidth: 24,
          minHeight: 24,
          padding: '4px',
          flexShrink: 0,
          ...style,
        }}
        aria-label={ariaLabel}
        aria-expanded={expanded}
        variant="text"
        onClick={onClick}
        color="primary"
      />
    </WbTooltip>
  );
};
